import { gql } from "@apollo/client";

export const DELETE_API_KEY = gql`
  mutation DeleteApiKey($id: ID!) {
    apiKeyDelete(id: $id) {
      id
    }
  }
`;
